import { createClient } from "@supabase/supabase-js";

import { getPublicRuntimeEnv } from "../../env.js";

const DEFAULT_AUTH_OPTIONS = Object.freeze({
  persistSession: true,
  autoRefreshToken: true,
  detectSessionInUrl: true,
});

let browserClient = null;

export function createSupabasePublicClient({ supabaseUrl, supabaseAnonKey, auth = DEFAULT_AUTH_OPTIONS } = {}) {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error("Supabase URL and anon key are required for the public client.");
  }

  return createClient(supabaseUrl, supabaseAnonKey, { auth });
}

export function getSupabaseBrowserClient(source = import.meta.env) {
  const runtimeEnv = getPublicRuntimeEnv(source);
  if (!runtimeEnv.supabaseConfigured) return null;

  if (!browserClient) {
    browserClient = createSupabasePublicClient({
      supabaseUrl: runtimeEnv.supabaseUrl,
      supabaseAnonKey: source.VITE_SUPABASE_ANON_KEY,
    });
  }

  return browserClient;
}

export function resetSupabaseBrowserClientForTests() {
  browserClient = null;
}
